var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 34,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14128 28.5054L5.08751 28.6897L11.7849 5.72827C11.8273 5.584 11.9274 5.53356 11.9963 5.51191C12.0216 5.50424 12.0592 5.49641 12.1007 5.49641C12.1562 5.49641 12.2201 5.5092 12.2919 5.56798C12.2919 5.56802 12.292 5.56806 12.292 5.5681L24.7675 15.8197L24.9336 15.9562L25.1304 15.8698L48.6855 5.52926C48.6856 5.52923 48.6856 5.52919 48.6857 5.52916C48.779 5.48844 48.8443 5.49371 48.8906 5.5065C48.9436 5.52115 48.9902 5.55169 49.025 5.58185C49.06 5.61341 49.0963 5.65622 49.1174 5.70709C49.1359 5.75155 49.1493 5.81609 49.12 5.91467L49.1196 5.91589L45.6466 17.777L45.5153 18.2254H45.9825H49.8819H50.1442L50.2178 17.9737L53.3793 7.17351L53.3794 7.17344C53.9056 5.37467 53.3618 3.48088 51.9611 2.23887C50.5599 0.996337 48.6204 0.69153 46.9068 1.44335L46.9067 1.44337L25.6424 10.7766L15.1 2.11489L15.0996 2.11457C13.8597 1.09896 12.2064 0.777686 10.6801 1.25207L10.6797 1.25217C9.15123 1.72889 7.97081 2.93428 7.52277 4.47375L0.826491 27.4388C0.442185 28.7539 0.692445 30.1395 1.50927 31.2352C2.32624 32.3312 3.58115 32.963 4.94697 32.963H38.5085H38.7707L38.8444 32.7114L39.9446 28.9537L40.0759 28.5054H39.6087H5.14128ZM5.14128 28.5054L11.7848 5.72861L5.14128 28.5054ZM5.0909 28.6487C5.09165 28.6658 5.08925 28.6809 5.08799 28.6873L4.95014 28.6499L4.94697 28.6491V28.5076C4.94326 28.5076 4.96564 28.507 4.99228 28.516C5.02321 28.5266 5.04852 28.5456 5.06305 28.5649C5.06906 28.5729 5.07627 28.5851 5.08193 28.6014C5.08752 28.6175 5.09025 28.6337 5.0909 28.6487Z",
    stroke: "url(#paint0_angular_5913_623)",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5913_623",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 53,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94697 28.8576C4.92267 28.8576 4.84535 28.8576 4.78348 28.7755C4.72162 28.6933 4.74372 28.6201 4.75035 28.5957L11.4489 5.63027C11.5373 5.32841 11.7649 5.21744 11.893 5.17748C11.9438 5.16195 12.0167 5.14641 12.1007 5.14641C12.2244 5.14641 12.3702 5.17971 12.5138 5.29734L24.9897 15.5493L48.5453 5.20856C48.8855 5.05985 49.1374 5.21522 49.2567 5.31953C49.376 5.42607 49.5616 5.6569 49.4555 6.01425L45.9825 17.8754H49.8819L53.0434 7.07518C53.5317 5.4061 53.028 3.65267 51.7289 2.50074C50.4298 1.34881 48.6359 1.06693 47.0474 1.76386L25.5863 11.1835L14.8778 2.38532C13.7289 1.44425 12.1979 1.14683 10.7839 1.5863C9.36778 2.02798 8.27418 3.1444 7.85883 4.57156L1.16244 27.537C0.808953 28.7466 1.03872 30.0184 1.78988 31.0261C2.54104 32.0337 3.69209 32.613 4.94697 32.613H38.5085L39.6087 28.8554H4.94697V28.8576Z",
    fill: "#0A1E4C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5913_623)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -12.13,
    width: 63,
    height: 58,
    fill: "#0A1E4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_5913_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2349 21.4772C43.0061 31.8002 56.952 40.9616 56.3839 41.9396C55.8157 42.9176 40.9488 35.3419 23.1776 25.0188C5.4064 14.6958 -8.53945 5.53444 -7.97134 4.55643C-7.40323 3.57842 7.46372 11.1541 25.2349 21.4772Z",
    fill: "url(#paint1_linear_5913_623)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_5913_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2349 36.3696C43.0061 46.6927 56.952 55.854 56.3839 56.832C55.8157 57.81 40.9488 50.2343 23.1776 39.9113C5.4064 29.5882 -8.53945 20.4269 -7.97134 19.4489C-7.40323 18.4708 7.46372 26.0465 25.2349 36.3696Z",
    fill: "url(#paint2_linear_5913_623)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_5913_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2349 3.69157C43.0061 14.0146 56.952 23.176 56.3839 24.154C55.8157 25.132 40.9488 17.5563 23.1776 7.23326C5.4064 -3.08981 -8.53945 -12.2511 -7.97134 -13.2292C-7.40323 -14.2072 7.46372 -6.6315 25.2349 3.69157Z",
    fill: "url(#paint3_linear_5913_623)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5913_623",
    x: -10.6164,
    y: 1.84336,
    width: 69.6448,
    height: 42.8093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31404,
    result: "effect1_foregroundBlur_5913_623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5913_623",
    x: -10.6164,
    y: 16.7358,
    width: 69.6448,
    height: 42.8093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31404,
    result: "effect1_foregroundBlur_5913_623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5913_623",
    x: -10.6164,
    y: -15.9422,
    width: 69.6448,
    height: 42.8093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31404,
    result: "effect1_foregroundBlur_5913_623"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_5913_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.33 16.9998) rotate(90) scale(15.6132 25.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#C8D4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434957,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532623,
    stopColor: "#AEC0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658692,
    stopColor: "#E3E9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708863,
    stopColor: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861413,
    stopColor: "#D6DFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#B8C9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5913_623",
    x1: -7.34826,
    y1: 7.18806,
    x2: -3.22385,
    y2: 0.835512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5913_623",
    x1: -7.34826,
    y1: 22.0805,
    x2: -3.22385,
    y2: 15.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5913_623",
    x1: -7.34826,
    y1: -10.5975,
    x2: -3.22385,
    y2: -16.9501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f6fe74ba5253bf0480408bae2d581ac.svg";
export { ForwardRef as ReactComponent };